import { Smartphone } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useMobileSigningLocale } from "@/i18n/use-mobile-signing-locale";

/** GatewayWalletResponse.signingTopology wire value for a Silence Trio
 * 2-of-3 wallet with the phone as the device party (ALL-4884). */
export const TRIO_2OF3_SIGNING_TOPOLOGY = "TRIO_2OF3";

/** "Phone co-signed (Trio)" chip, shown only for wallets bound to the real
 * Trio 2-of-3 signing topology — absent (renders nothing) for every other
 * wallet, never a default/fabricated badge. */
export function SigningTopologyChip({ signingTopology }: { signingTopology?: string | null }) {
  const catalog = useMobileSigningLocale();
  if (signingTopology !== TRIO_2OF3_SIGNING_TOPOLOGY) return null;
  return (
    <Badge variant="info" dot={false} size="sm" dir={catalog.dir} data-testid="signing-topology-chip">
      <Smartphone aria-hidden className="size-3" />
      {catalog.wallet.trioChip}
    </Badge>
  );
}
